// Cobram Estate Awards - Interactive Functionality using jQuery
const cards = document.querySelectorAll('.awards-product-card');
const details = document.querySelectorAll('.product-awards-details');

cards.forEach(card => {

    card.addEventListener('click', function () {

        const productId = this.dataset.productId;

        // Remove active classes
        cards.forEach(c => c.classList.remove('active'));
        details.forEach(d => d.classList.remove('active'));

        // Activate selected card
        this.classList.add('active');

        // Activate matching details
        const detail = document.querySelector(
            `.product-awards-details[data-product-details="${productId}"]`
        );

        if (detail) {
            detail.classList.add('active');
        }

    });

});
jQuery(document).ready(function () {
 
    // jQuery(".awards-product-grid").each(function () {
 
    //     const $tableWrap = jQuery(this);
 
    //     let isDown = false;
    //     let startX = 0;
    //     let scrollLeft = 0;
 
    //     $tableWrap.on("mousedown", function (e) {
    //         isDown = true;
    //         $tableWrap.addClass("active");
 
    //         startX = e.pageX - $tableWrap.offset().left;
    //         scrollLeft = $tableWrap.scrollLeft();
    //     });
 
    //     $tableWrap.on("mouseleave mouseup", function () {
    //         isDown = false;
    //         $tableWrap.removeClass("active");
    //     });
 
    //     $tableWrap.on("mousemove", function (e) {
    //         if (!isDown) return;
 
    //         e.preventDefault();
 
    //         const x = e.pageX - $tableWrap.offset().left;
    //         const walk = (x - startX) * 2; // Drag speed
 
    //         $tableWrap.scrollLeft(scrollLeft - walk);
    //     });
 
    // });

 
});
$(document).ready(function() {
  // 1. Click Handler for Product Cards in Explorer Grid
  $('#productGrid').on('click', '.product-card', function() {
    const $card = $(this);
    if ($card.hasClass('active')) return; // Already active

    // Swap active card outlines
    $('.product-card').removeClass('active');
    $card.addClass('active');

    // Get selected product id
    const productId = $card.data('product-id');
    const $targetDetails = $(`.product-details-container[data-product-details="${productId}"]`);

    // Fade out currently active detail container and fade in target container
    $('.product-details-container').removeClass('active').hide();
    $targetDetails.fadeIn(300).addClass('active');

    // Smooth scroll to the active details container on mobile viewports
    if (window.innerWidth < 768) {
      $('html, body').animate({
        scrollTop: $targetDetails.offset().top - 80
      }, 500);
    }
  });
});
